import { intlTag } from '@/i18n';

export function formatClock(ts: number): string {
  return new Intl.DateTimeFormat(intlTag(), { hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(ts));
}

export function formatDateTime(ts: number): string {
  return new Intl.DateTimeFormat(intlTag(), { month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(ts));
}

export function formatShortDate(ts: number): string {
  return new Intl.DateTimeFormat(intlTag(), { year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(ts));
}

/** "YYYY-MM-DD" → localized month/day heading, e.g. "9月15日" / "Sep 15". */
export function formatMonthDay(isoDate: string): string {
  const [y, m, d] = isoDate.split('-').map(Number);
  return new Intl.DateTimeFormat(intlTag(), { month: 'long', day: 'numeric' }).format(new Date(y, m - 1, d));
}
